import { TypePolicies } from "@apollo/client";

export const TYPE_POLICIES: TypePolicies = {
  // у TaskDashboardDto нет id: разные запросы дополняют один объект
  TaskDashboardDto: { merge: true },
  // Вложенные объекты задачи без id: карточка, список и блок итераций читают у одной
  // задачи разные наборы полей — без merge Apollo заменял бы объект целиком, терял поля
  // и заново перезапрашивал соседний запрос
  TaskPermissions: { merge: true },
  OneTimeCompletionDto: { merge: true },
  RecurringCompletionDto: { merge: true },
  TaskReminderDto: { merge: true },
  // Повторы серии зависят от окна запроса: нормализованная по id серия показывала бы
  // в октябре повторы, пришедшие за ноябрь, пока сеть не ответит
  RecurringExternalCalendarEmployeeEvent: { keyFields: false },
  RecurringTaskEmployeeEvent: { keyFields: false },
  // у AssessmentParticipantAnswerDto нет id: прохождение опроса читает items, рекрутинг —
  // только тоталы; без merge поздняя запись тоталов стирала items и сохранение ответа падало
  AssessmentParticipantAnswerDto: { merge: true },
};
